/* ==========================================
   NAVURA - Mobile header wishlist hand-off

   The wishlist app (Wishlist by Square) injects its own trigger element
   into the page via its own script, on its own schedule. Rather than
   hardcode a guessed route, we wait for its real element to appear and
   move it (not clone it, so its event listeners are preserved) into our
   mobile header's wishlist slot. If it never appears within a few
   seconds, the slot simply stays empty — no error, no broken layout.
========================================== */

(function () {
  var SELECTOR = '.Vtl-WishlistHeaderWrapper';
  var TIMEOUT_MS = 8000;

  var mobileQuery = window.matchMedia('(max-width: 749px)');

  function placeWishlistIcon() {
    var slot = document.querySelector('[data-navura-wishlist-slot]');
    var target = document.querySelector(SELECTOR);
    if (!target) return false;

    if (!mobileQuery.matches) {
      var desktopIcons = document.querySelector('.header__icons');
      var cartIcon = desktopIcons && desktopIcons.querySelector('#cart-icon-bubble');
      if (desktopIcons && target.closest('[data-navura-wishlist-slot]')) {
        desktopIcons.insertBefore(target, cartIcon || null);
      }
      return true;
    }

    if (!slot) return true;
    var fallback = slot.querySelector('.navura-mobile-header__wishlist-fallback');
    if (fallback) fallback.remove();
    if (!target.closest('[data-navura-wishlist-slot]')) slot.appendChild(target);
    return true;
  }

  document.addEventListener('DOMContentLoaded', function () {
    mobileQuery.addEventListener('change', placeWishlistIcon);
    if (placeWishlistIcon()) return;

    var observer = new MutationObserver(function () {
      if (placeWishlistIcon()) observer.disconnect();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(function () {
      observer.disconnect();
    }, TIMEOUT_MS);

    var voiceButton = document.querySelector('.navura-mobile-header__voice');
    var searchInput = document.querySelector('#Navura-Mobile-Search');
    var searchForm = searchInput && searchInput.form;
    var Recognition = window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!voiceButton || !searchInput || !Recognition) {
      if (voiceButton) voiceButton.hidden = true;
      return;
    }

    var recognition = new Recognition();
    recognition.lang = document.documentElement.lang || 'en-IN';
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;

    voiceButton.addEventListener('click', function () {
      voiceButton.classList.add('is-listening');
      voiceButton.setAttribute('aria-label', 'Listening');
      try {
        recognition.start();
      } catch (error) {
        voiceButton.classList.remove('is-listening');
        voiceButton.setAttribute('aria-label', 'Search by voice');
      }
    });

    recognition.addEventListener('result', function (event) {
      var transcript = event.results[0][0].transcript.trim();
      if (!transcript) return;
      searchInput.value = transcript;
      if (searchForm) searchForm.submit();
    });

    recognition.addEventListener('end', function () {
      voiceButton.classList.remove('is-listening');
      voiceButton.setAttribute('aria-label', 'Search by voice');
    });

    recognition.addEventListener('error', function () {
      voiceButton.classList.remove('is-listening');
      voiceButton.setAttribute('aria-label', 'Search by voice');
    });
  });
})();
